import { render } from "./CircularesComponent.vue?vue&type=template&id=b8367dfa&scoped=true"
import script from "./CircularesComponent.vue?vue&type=script&lang=js"
export * from "./CircularesComponent.vue?vue&type=script&lang=js"

import "./CircularesComponent.vue?vue&type=style&index=0&id=b8367dfa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8367dfa"]])

export default __exports__